import { FormFieldTypes } from "../../../../../data/formFieldType";

export const EventListFilterFormData = {
    name: "EventListFilterFormData",
    initialState: {
        eventName: '',
        status: '',
        hidden: '',
    },
    formFields: [
        {
            id: "eventName",
            lable: "Search by Event Name",
            Field_Name: "Search by Event Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "eventName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-2",
            },
        },
        {
            id: "status",
            lable: "Status",
            Field_Name: "Status",
            fieldType: FormFieldTypes.SELECT,
            dataField: "status",
            fieldSetting: {
                placeholder: "Select",
                options: [
                    { value: 1, label: 'Draft' },
                    { value: 2, label: 'Submitted' },
                    { value: 12, label: 'Approved' },
                ],
            },
            style: {
                containerCss: "col-lg-4 mb-2",
            }
        },
        {
            id: "hidden",
            lable: "Hidden",
            Field_Name: "Hidden",
            fieldType: FormFieldTypes.SELECT,
            dataField: "hidden",
            fieldSetting: {
                placeholder: "Select",
                options: [
                    { value: 1, label: "Yes" },
                    { value: 2, label: "No" },
                ],
            },
            style: {
                containerCss: "col-lg-4 mb-2",
            }
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}